@import 'styles/mixins';
@import 'styles/variables';

.actionModalContainer {
  :global .ant-modal-body {
    padding: 0;
  }

  :global .ant-modal-content {
    border-radius: 8px;
  }
}

.confirmation {
  .header {
    padding-top: 24px;
    padding-bottom: 0px;
  }

  .confirmationBody {
    padding: 24px 24px 16px 24px;

    .confirmationTitle {
      @include ui-lg-bold;

      color: $gray-90;
    }

    .confirmationText {
      @include body-md-text;

      color: $gray-90;

      .listWithBullets {
        padding-left: 22px;

        li {
          list-style-type: disc;
        }
      }
    }
  }

  .confirmationFooter {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 24px;
  }
}

.header {
  @include header-md;

  align-items: center;
  color: $almanac-black;
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;

  .headerText {
    flex: 0 0 calc(100% - 50px);
    margin-right: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.body {
  height: calc(50vh + 60px);
  padding: 8px 24px 0px;
}

.breadcrumb {
  border-bottom: 1px solid $gray-20;
  margin-bottom: 12px;
  padding: 8px 0;
}

.table {
  max-height: calc(50vh - 4px);
  overflow-y: auto;
  margin-top: 12px;

  @include for-phone-only {
    max-height: initial;
  }

  .tableHeader {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    padding: 12px;
    width: 100%;

    @include for-phone-only {
      justify-content: space-between;
    }

    .title {
      align-items: center;
      display: flex;
      flex: 0 0 60%;

      & svg {
        fill: $gray-40;
        margin-left: 8px;
      }
    }

    > * {
      color: $gray-40;
      flex: 0 0 20%;
      font-size: 10px;
      font-weight: 500;
      line-height: 1.6;
      text-transform: uppercase;
    }
  }
}

.bold {
  font-weight: 600;
}

.footer {
  align-items: center;
  border-top: 1px solid $grey-5;
  display: flex;
  justify-content: space-between;
  padding: 24px;

  .buttonContainer {
    display: flex;
    align-items: center;
    > * + * {
      margin-left: 12px;
      padding: 7px 16px;
      height: auto;
    }

    .buttonWrapper {
      padding: 0px;

      Button {
        padding: 7px 16px;
      }
    }
  }
}

.newFolderInput {
  margin-left: 16px;
  margin-bottom: 8px;
  div:nth-child(1) {
    flex-grow: 1;
    padding: 6px 8px;
    border: 1px solid var(--focus-50);
    box-shadow: 0px 0px 5px 1px var(--focus-10);
    border-radius: 4px;
    input {
      @include md-medium;
      color: $grey-90;
    }
  }
  div {
    display: none;
  }
}

.emptyState {
  padding: 160px 0;
  text-align: center;
  width: 100%;

  .emptyHeader {
    @include ui-md-text;
    color: $gray-90;
  }

  .emptyText {
    @include ui-sm-text;
    color: $gray-40;
    margin-top: 4px;
  }
}

.actionModalPopoverContent {
  @include ui-md-text;

  background-color: $white;
  border-radius: 8px;
  box-shadow: 0px 1px 1px rgba(19, 21, 26, 0.12), 0px 8px 24px rgba(19, 21, 26, 0.12);
  color: $gray-50;
  padding: 24px;
  width: 332px;
}

.actionModalPopoverTitle {
  @include ui-lg-bold;

  color: $gray-90;
  margin-bottom: 24px;
}
